/**
 * @created        16/09/2023 - 17:09
 * @author         Nariman Palangi
 * @user           ragnarok
 * @organization
 * @project        Azmiun
 * @file name      useErrorHandler.js
 * @file dir       src/composable
 */
// Handler
// handle server or connection errors

// import { clearAuth } from "@/services/AuthService.service";

const handler = {
    // handle errors
    error(result) {
        try {
            let error = new ServerError(
                result.response.status,
                result.response.data.message,
                result.response.data.errors
            );
            return Promise.reject({
                error: error,
                header: result.response.headers,
            });

        } catch (e) {
            return Promise.reject({
                error: e,
                header: result.response.headers,
            });
        }
    },

    // handle response
    response(result) {
        try {
            return {
                headers: result.headers,
                data: result.data,
            };
        } catch (e) {
            return Promise.reject(result);
        }
    },
};

class ServerError {
    status;
    message;
    errors;
    validationErrors;
    constructor(status, message, errors, validationErrors = []) {
        try {
            this.status = +status;
            this.message = message;
            this.errors = errors;
            this.validationErrors = validationErrors;
        } catch (e) {
            this.status = null;
            this.message = null;
            this.errors = null;
            this.validationErrors = [];
        }
    }
}

export const useApiResponseHandler = handler;
